<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid, Autoplay, Pagination} from 'swiper/modules';
import ModelScene from "../ModelScene.vue";

const slides = [
    {
        title: 'Всё <br>в кармане',
        text: 'Чарлисты, миры и&nbsp;целые редакции всегда и&nbsp;всюду с&nbsp;тобой'
    },
    {
        title: 'Расчёты <br>автоматом',
        text: 'Любые баффы и&nbsp;дебаффы считаются молниеносно'
    },
    {
        title: 'Быстрый <br>поиск',
        text: 'По&nbsp;заметкам, предметам инвентаря, кастам, умениям и&nbsp;навыкам'
    },
    {
        title: 'Записи <br>в порядке',
        text: 'Систематизация, цветовые ярлычки, разборчивый &laquo;почерк&raquo; и&nbsp;никаких дыр'
    },
];
</script>

<template>
    <section id="main" class="group section-screen mt-32 lg:mt-0">
        <div class="relative max-w-full w-[1536px] mx-auto px-6">
            <div class="md:pt-10 lg:pt-6 md:w-2/3 lg:w-7/12">
                <div class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none text-black dark:text-white">
                    В чём<br>
                    плюсы?
                </div>
                <div class="text-xs md:text-md lg:text-lg my-1 md:my-3 text-green">&mdash; рассказываем значит</div>
            </div>
            <div class="flex pt-7 md:pt-12 xl:pt-16 justify-end lg:pr-[4%]">
                <div class="relative lg:flex-none w-full lg:w-[64.7%] mb-[10%] xl:mb-[8%] mt-2 lg:mt-16">
                    <div class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-bold leading-none text-black dark:text-white">
                        Ноль рутины
                    </div>
                    <div class="mt-3 text-sm md:mt-5 md:text-[1rem] !leading-normal">
                        Тут посчитай, там найди, тут перезапиши&nbsp;&mdash; монотонные повторяющиеся действия убивают всю
                        волшебную атмосферу и&nbsp;крадут драгоценное время приключения, а&nbsp;пати-то ждёт...<br><br>
                        Quenta забирает эту раздражающую суету на&nbsp;себя, чтобы игры становились насыщенными отыгрышем
                    </div>

                    <div class="bg-green rounded-sm h-[2px] w-[44px] mt-8 mb-7 mx-auto md:hidden"></div>
                    <swiper
                        wrapperTag="ul"
                        class="mt-8 md:mt-8 xl:mt-7 pb-12 overflow-hidden relative"
                        :modules="[Autoplay, Grid, Pagination]"
                        :slidesPerView="1"
                        :spaceBetween="0"
                        :allowTouchMove="true"
                        :autoplay="{
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        }"
                        :grid="{
                            rows: 1
                        }"
                        :loop="true"
                        :pagination="{
                            el: '.swiper-pagination',
                            enabled: true,
                            clickable: true
                        }"
                        :breakpoints="{
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 44,
                                allowTouchMove: false,
                                grid: {
                                    rows: 3,
                                    fill: 'row'
                                },
                                pagination: {
                                    enabled: false
                                }
                            },
                        }"
                    >
                        <swiper-slide v-for="slide in slides" tag="li" class="mt-2 lg:mt-2 xl:mt-4">
                            <div class="text-xl md:text-3xl lg:text-[2.5rem] font-bold leading-none tracking-tighter text-black dark:text-white" v-html="slide.title"></div>
                            <div class="pt-3 text-sm md:mt-5 md:text-[1rem] !leading-normal" v-html="slide.text"></div>
                        </swiper-slide>
                        <div class="swiper-pagination text-green"></div>
                    </swiper>

                    <div class="screen-dice-wrapper absolute right-[106%] -top-[5%] -bottom-[5%] max-w-[51%] w-[543px] lg:block 2xl:text-center  duration-1000 opacity-0 transition-opacity group-[.visited]:opacity-100">
                        <img src="/images/phone-2.png" alt="" class="inline-block max-w-full max-h-full transition-transform duration-1000 -translate-x-[20%] group-[.visited]:translate-x-0 dark:hidden">
                        <img src="/images/phone-2-dark.png" alt="" class="max-w-full max-h-full transition-transform duration-1000 -translate-x-[20%] group-[.visited]:translate-x-0 hidden dark:inline-block">

                        <div class="screen-dice d4"></div>
                        <div class="screen-dice d6"></div>
                        <div class="screen-dice d8"></div>
                        <div class="screen-dice d10"></div>
                        <div class="screen-dice d20"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    #main .screen-dice {
        &.d4 {
            @apply bottom-[75%] left-[50%] md:bottom-[85%] md:left-[70%];
        }

        &.d6 {
            @apply hidden;
        }

        &.d8 {
            @apply hidden;
        }

        &.d10 {
            @apply top-[85%] right-[70%] md:top-[85%] md:right-[70%];
        }

        &.d20 {
            @apply top-[30%] right-[60%] md:top-[30%] md:right-[60%];
        }
    }
</style>
